import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ToastComponent } from "../../../../../shared/components/toast/toast.component";
import { AdminTopbarComponent } from "../../../components/admin-topbar/admin-topbar.component";
import { AdminNavigationComponent } from "../../../components/admin-navigation/admin-navigation.component";
import { CustomButtonComponent } from "../../../../../shared/components/custom-button/custom-button.component";
import { TranslocoPipe } from '@jsverse/transloco';
import { DeleteConfirmationDialogComponent } from "../../../../../shared/dialogs/delete-confirmation-dialog/delete-confirmation-dialog.component";
import { CommonModule } from '@angular/common';
import { SalesEngineDataService } from '../../../../../core/services/sales-engine-data.service';
import { SalesEngineService } from '../../../../../core/api/sales-engine.service';
import { ApiErrorService } from '../../../../../core/api/api-error.service';
import { SignalGet } from '../../../../../core/interfaces/sales-engine-interfaces';
import { lastValueFrom } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { CreateEditSignalComponent } from "../../../components/upsell-engine/create-edit-signal/create-edit-signal.component";

@Component({
  selector: 'app-admin-signals-page',
  standalone: true,
  imports: [ToastComponent, AdminTopbarComponent, AdminNavigationComponent, CustomButtonComponent, TranslocoPipe, DeleteConfirmationDialogComponent, CommonModule, CreateEditSignalComponent],
  templateUrl: './admin-signals-page.component.html',
  styleUrl: './admin-signals-page.component.css'
})
export class AdminSignalsPageComponent implements OnInit {
  constructor(private salesEngineData: SalesEngineDataService, private salesEngine: SalesEngineService, private apiError: ApiErrorService, private cdRef: ChangeDetectorRef) { }

  @ViewChild(ToastComponent) toast?: ToastComponent;

  @ViewChild(DeleteConfirmationDialogComponent) deleteDialog!: DeleteConfirmationDialogComponent;
  @ViewChild('editCreateRef') editCreateRef!: ElementRef;

  isEditCreateOpen: boolean = false;
  isEditing: boolean = false;
  selectedSignal?: SignalGet;

  get signals(): Array<SignalGet> {
    return this.salesEngineData.getSignals();
  }

  reloadSignals = () => this.salesEngineData.reloadSignals();

  ngOnInit(): void {
    this.cdRef.detectChanges();
  }

  createSignal() {
    if (this.isEditCreateOpen) {
      this.isEditCreateOpen = false;
      this.cdRef.detectChanges();
    }

    this.isEditCreateOpen = true;
    this.cdRef.detectChanges();



    this.isEditing = false;
    this.selectedSignal = undefined;

    this.editCreateRef.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
  }

  editSignal(signal: SignalGet) {
    if (this.isEditCreateOpen) {
      this.isEditCreateOpen = false;
      this.cdRef.detectChanges();
    }

    this.isEditCreateOpen = true;
    this.cdRef.detectChanges();

    this.isEditing = true;
    this.selectedSignal = signal;

    this.editCreateRef.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
  }

  async deleteSignal(signal: SignalGet) {
    if (!await this.deleteDialog.openModal()) {
      return;
    }

    try {
      await lastValueFrom(this.salesEngine.deleteSignal(signal.id));

      this.reloadSignals();
    } catch (error) {
      var crid = 'UNKNOWN-CRID';
      if (error instanceof HttpErrorResponse) {
        crid = error.headers?.get('x-correlation-id') || 'UNKNOWN-CRID';
      }
      this.toast?.showToast(await this.apiError.getErrorHeader(), await this.apiError.getErrorMessage(crid), 'error', 8000, false);
      return;
    }
  }
}
